var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-12" }, [
      _c(
        "div",
        {
          staticClass: "data-load",
          class: {
            "sk-loading": _vm.showSpinner,
            card: !_vm.stickyTable,
            "data-load--scroll-x": _vm.stickyTable,
          },
        },
        [
          _vm.showSpinner ? _c("sk-spinner") : _vm._e(),
          _c("div", { class: { "card-body": !_vm.stickyTable } }, [
            _c("div", [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col col-sm-8 col-md-8 col-lg-8" }, [
                  _vm.rows.length > 0
                    ? _c("h4", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.rows.length) +
                            " " +
                            _vm._s(_vm.$t("components.table.results")) +
                            " "
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm.showRefreshButton
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "col col-sm-4 col-md-4 col-lg-4 text-right",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "p-2 float-right btn-refresh",
                            attrs: { href: "#" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.refreshButtonClicked.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [_c("i", { staticClass: "fas fa-sync-alt" })]
                        ),
                      ]
                    )
                  : _vm._e(),
              ]),
            ]),
            _c(
              "div",
              {
                class: _vm.stickyTable ? "table-scroll-x" : "table-responsive",
              },
              [
                _c("table", { class: _vm.classTable }, [
                  _c("thead", [
                    _c(
                      "tr",
                      [
                        _vm.showRowTableAction
                          ? _c(
                              "th",
                              {
                                class: {
                                  sticky_column_action: _vm.stickyTable,
                                },
                              },
                              [_vm._v("   ")]
                            )
                          : _vm._e(),
                        _vm._l(
                          _vm.tableColumns,
                          function (column, column_index) {
                            return _c(
                              "th",
                              {
                                key: column.id + "_" + column_index,
                                class: _vm.addStickyClassHeader(
                                  column_index,
                                  column.classHeader
                                ),
                                style: column.styleHeader,
                              },
                              [
                                !column.useTranslate
                                  ? _c("span", [_vm._v(_vm._s(column.name))])
                                  : _c("span", [
                                      _vm._v(_vm._s(_vm.$t(column.name))),
                                    ]),
                              ]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                  _vm.rows.length > 0
                    ? _c(
                        "tbody",
                        _vm._l(_vm.rows, function (row, index_row) {
                          return _c(
                            "tr",
                            {
                              key:
                                index_row + "_" + new Date().getMilliseconds(),
                            },
                            [
                              _vm.showRowTableAction
                                ? _c(
                                    "td",
                                    {
                                      class: {
                                        "td-align-left": true,
                                        "text-center": true,
                                        "p-1": true,
                                        sticky_column_action: _vm.stickyTable,
                                      },
                                      style: { width: "60px !important" },
                                    },
                                    [
                                      _vm._t(
                                        "table-action",
                                        function () {
                                          return [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "dropdown table-action-dropdown",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn btn-default table-action-btn",
                                                    attrs: {
                                                      type: "button",
                                                      id: "dropdownMenuButton",
                                                      "data-toggle": "dropdown",
                                                      "data-boundary": "window",
                                                      "data-display": "dynamic",
                                                      "aria-haspopup": "true",
                                                      "aria-expanded": "false",
                                                      "aria-label": _vm.$t(
                                                        "pages.planing-team.actions"
                                                      ),
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "fas fa-ellipsis-v",
                                                    }),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "dropdown-menu table-action-menu",
                                                    attrs: {
                                                      "aria-labelledby":
                                                        "dropdownMenuButton",
                                                    },
                                                  },
                                                  [
                                                    _vm._t(
                                                      "table-action-menu",
                                                      null,
                                                      { row: row }
                                                    ),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        { row: row }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._l(row.getCells, function (cell, index_cell) {
                                return _c(
                                  "td",
                                  {
                                    key: index_cell,
                                    class: _vm.addStickyClassCell(
                                      index_cell,
                                      cell.getColumn.classCell
                                    ),
                                    style: cell.getColumn.styleCell,
                                  },
                                  [
                                    _vm._t(
                                      "table-row",
                                      function () {
                                        return [
                                          _c("span", [
                                            _vm._v(_vm._s(cell.getValue)),
                                          ]),
                                        ]
                                      },
                                      { cell: cell, row: row }
                                    ),
                                  ],
                                  2
                                )
                              }),
                            ],
                            2
                          )
                        }),
                        0
                      )
                    : _c("tbody", [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: _vm.tableColumns.length + 1 },
                            },
                            [_vm._v(" " + _vm._s(_vm.emptyRowsMessage) + " ")]
                          ),
                        ]),
                      ]),
                  _vm.showFooterTable
                    ? _c("tfoot", [
                        _c(
                          "tr",
                          _vm._l(
                            _vm.tableColumns,
                            function (column, column_index) {
                              return _c(
                                "td",
                                {
                                  key:
                                    column_index +
                                    "_" +
                                    new Date().getMilliseconds() +
                                    "_foot_column",
                                },
                                [
                                  _vm._t("table-tfoot-row", null, {
                                    column: column,
                                  }),
                                ],
                                2
                              )
                            }
                          ),
                          0
                        ),
                      ])
                    : _vm._e(),
                ]),
              ]
            ),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col" }, [_vm._t("description")], 2),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }